/**
 * Returns the first finite numeric value without treating a legitimate zero as
 * a missing value. API responses use a few aliases for the same consumption
 * fields, so callers can pass those aliases in priority order.
 */
export const firstFiniteConsumption = (...values: unknown[]): number | null => {
  for (const value of values) {
    if (
      value === null ||
      value === undefined ||
      (typeof value === 'string' && value.trim() === '')
    ) {
      continue
    }

    const numericValue = Number(value)
    if (Number.isFinite(numericValue)) return numericValue
  }

  return null
}

/** One display for consumption in tables and charts: a real 0 shows as 0.00, only a missing value shows a dash. */
export const formatConsumptionValue = (
  value: unknown,
  fractionDigits = 2
): string => {
  const numericValue = firstFiniteConsumption(value)
  if (numericValue === null) return '-'

  const formatted = numericValue.toFixed(fractionDigits)
  return Number(formatted) === 0 ? (0).toFixed(fractionDigits) : formatted
}
